import { ReactNode } from 'react';

const PageLayout = ({ children }: { children: ReactNode }) => {
  return <div className="pt-5 pb-5 pr-20 pl-20">{children}</div>;
};

export default PageLayout;
